import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null,
    userInfo: null,
    serverhosts: 'https://hgz.api.sdmxty.cn/',
    snack: [],
    viewimg: '',
    glimit: 20,
    gzhichi: '',
    guser: '无棣县农业农村局',
  },
  /**
   * vuex的mutations属性是用来初步获取和简单处理state里面的数据,通过mutations更新的数据，视图同步更新。
   * 调用mutations的时候，使用this.$store.commit("actionsName",playload)
   */
  mutations: {
    settoken(state, token){
      sessionStorage.setItem("token", JSON.stringify(token))
      state.token = token
    },
    setuserInfo(state, userInfo){
      sessionStorage.setItem("userInfo", JSON.stringify(userInfo))
      state.userInfo = userInfo
    },
    setsnack(state, obj){
      state.snack.push(obj)
    },
    setviewimg(state, value){
      state.viewimg = value
    },
  },
  /**
   * vuex的actions属性是用来处理异步方法的，通过提交mutations实现。
   * 调用actions的时候，使用this.$store.dispatch("actionsName",playload)
   */
  actions: {
    settoken(context, token){
      context.commit('settoken', token)
    },
    setuserInfo({commit}, userInfo){
      commit('setuserInfo', userInfo)
    },
    setsnack({commit}, obj){
      commit('setsnack', obj)
    },
    setviewimg({commit}, value){
      commit('setviewimg', value)
    },
  },
  modules: {
  }
})
